export enum FILTER_KEYS {
  DATE_RANGE = 'dateRange',
  DATE_RANGE_COMPARISON = 'comparisonDateRange',
}
